import React, {Component} from 'react';
import Select from 'react-select';
import axios from 'axios';

export default class ContractFundingSearchKAE extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: "",
            kae: [{value: "", label: window.__js_general.all2}],
        };

        this.handleKAEChange = this.handleKAEChange.bind(this);
        this.getKAE = this.getKAE.bind(this);
    }

    componentWillMount() {
        this.setState({
            id: this.props.id === undefined ? "" : this.props.id
        }, () => {
            this.getKAE();
        });
    }

    getKAE() {
        axios
            .get("/contracts/ajax/kae")
            .then((response) => {
                let items = [
                    {value: "", label: window.__js_general.all2}
                ];
                for (let key in response.data) {
                    if (response.data.hasOwnProperty(key)) {
                        let item = response.data[key];

                        items.push({
                            value: item.id,
                            label: item.title
                        });
                    }
                }

                this.setState({kae: items});
            });
    }

    handleKAEChange(e) {
        let kae_id = 0;
        if (e != null)
            kae_id = e.value;
        this.setState({
            id: kae_id
        });
    }

    render() {
        return (
            <div>
                <div className="form-group">
                    <label htmlFor="kae_id" className="col-md-4 control-label">
                        {window.__js_contracts.kae}
                    </label>
                    <div className="col-md-8">
                        <Select name="kae_id"
                                id="kae_id"
                                clearable={false}
                                value={this.state.id}
                                options={this.state.kae}
                                onChange={this.handleKAEChange}>
                        </Select>
                    </div>
                </div>
            </div>
        );
    }
}